import { useCallback, useEffect, useRef, useState } from 'react';
import { useDebounce } from '@ff-os/shared-react/hooks/useDebounce';

export const useNewSuccessfulUploadsCount = (
    photoIds: string[],
    { since }: { since: number }
) => {

    const lastPhotoIds = useRef(photoIds);
    const [count, setCount] = useState(0);

    const reset = useCallback(() => {
        setCount(0);
        lastPhotoIds.current = photoIds;
    }, [photoIds]);

    const debouncedReset = useDebounce(reset, since);

    useEffect(() => {

        // Ensures removed images are not kept in state
        lastPhotoIds.current = lastPhotoIds.current.filter(l => photoIds.includes(l));

        if (photoIds.length > lastPhotoIds.current.length) {
            setCount(photoIds.length - lastPhotoIds.current.length);
        }

        debouncedReset();

    }, [photoIds, debouncedReset]);

    return count;
};